import cloneDeep from 'lodash/fp/cloneDeep'
import {
  ADMINISTRATOR_LOGGED_IN,
  ADMINISTRATOR_LOGGED_OUT,
  ADMINISTRATOR_LOGGING_IN,
  ADMINISTRATOR_LOGIN_FAILED,
  ADMINISTRATOR_SET_EMAIL_ADDRESS,
  ADMINISTRATOR_SET_PASSWORD
} from './administrationLoginContainerActions'
import { validiateTextField } from '../../common/forms/validationFunctions'

const localStorage = global.localStorage
let token = null
let administratorLoggedIn = null
let administratorName = ''
let administratorId = null
if (localStorage) {
  token = localStorage.getItem('token')
  administratorLoggedIn = localStorage.getItem('isAdmin')
  administratorName = localStorage.getItem('userName')
  administratorId = localStorage.getItem('administratorId')
}

const initialState = {
  submitting: false,
  emailAddress: '',
  emailAddressEdited: false,
  password: '',
  passwordEdited: false,
  loginFailed: false,
  loginSucceeded: administratorLoggedIn !== null && token !== null,
  administratorName: administratorName,
  administratorId: administratorId,
  token: token,
  isInvalid: {
    formIsValid: false,
    emailAddress: {
      isInvalid: false,
      message: null
    },
    password: {
      isInvalid: false,
      message: null
    }
  }
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case ADMINISTRATOR_SET_EMAIL_ADDRESS:
      newState.emailAddress = action.emailAddress
      newState.emailAddressEdited = true
      newState.isInvalid.emailAddress = validiateTextField(action.emailAddress, null, true)
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    case ADMINISTRATOR_SET_PASSWORD:
      newState.password = action.password
      newState.passwordEdited = true
      newState.isInvalid.password = validiateTextField(action.password, null, true)
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    case ADMINISTRATOR_LOGGED_IN:
      newState.submitting = false
      newState.loginFailed = false
      newState.loginSucceeded = true
      newState.password = ''
      newState.token = action.payload.token
      newState.administratorName = action.payload.administratorName
      newState.administratorId = action.payload.administratorId
      if (localStorage && action.payload.token) {
        localStorage.setItem('token', JSON.stringify(action.payload.token))
        localStorage.setItem('userName', action.payload.administratorName)
        localStorage.setItem('isAdmin', JSON.stringify(true))
        localStorage.setItem('administratorId', JSON.stringify(action.payload.administratorId))
      }
      return newState
    case ADMINISTRATOR_LOGGING_IN:
      newState.submitting = true
      clearLocalStorageValues()
      return newState
    case ADMINISTRATOR_LOGGED_OUT:
      clearLocalStorageValues()
      newState.administratorName = ''
      newState.token = null
      newState.administratorId = null
      newState.loginSucceeded = false
      return newState
    case ADMINISTRATOR_LOGIN_FAILED:
      newState.submitting = false
      newState.loginFailed = true
      newState.loginSucceeded = false
      newState.password = ''
      return newState
  }
  return state
}

function formIsValid (state) {
  return state.emailAddressEdited &&
      state.passwordEdited &&
      state.isInvalid.emailAddress.isInvalid !== true &&
      state.isInvalid.password.isInvalid !== true
}

function clearLocalStorageValues () {
  if (localStorage) {
    localStorage.removeItem('token')
    localStorage.removeItem('userName')
    localStorage.removeItem('isAdmin')
    localStorage.removeItem('administratorId')
  }
}
